<template>
  <div>
    <LoginWithoutPass v-if="$store.state.loginCurrentStatePage == $store.state.loginStatesPage.LoginWithoutPass" />
    <div v-else>
      <LoginMSAL />
    </div>
  </div>
</template>

<script>
import LoginWithoutPass from '@/components/security/LoginWithoutPass.vue';
import LoginMSAL from '@/components/security/LoginMSAL.vue';

export default {
  components: {
    LoginWithoutPass,
    LoginMSAL
  }
};
</script>
<style lang="scss" scoped>
</style>
